
export default function Banner(params) {
    return (
        <div className='Banner'>
            <p><i>{params.text}</i></p>
        </div>
    );
}